import { isPlatformBrowser } from '@angular/common';
import { Component, Input, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FreeTrialNotifyComponent } from '../free-trial-notify/free-trial-notify.component';
import { LoginWithEmailComponent } from '../login-with-email/login-with-email.component';
import { LoginComponent } from '../login/login.component';
import { TrialUserComponent } from '../trial-user/trial-user.component';

@Component({
  selector: 'app-resource-video-view',
  templateUrl: './resource-video-view.component.html',
  styleUrls: ['./resource-video-view.component.css']
})
export class ResourceVideoViewComponent implements OnInit {
  @Input() ImageURL!: any;
  @Input() Link!: any;
  @Input() isPackageVideo: boolean | undefined;
  @Input() AccessStatus!: any;
  @Input() UserId!: any;
  @Input() UnPaidContent!: boolean;
  isBrowser: boolean = false;

  VideoSrc!: string;
  VideoLink!: string;
  UserID!: number;
  id: any;
  isTrialPending = false;
  isTrialExpired = false;
  isPackageExpired = false;
  freeTrialStatus: any;
  videoUrl: string = '';

  constructor(private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    @Inject(PLATFORM_ID) private platformId: any) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    this.openVideoIsAccess(this.Link);
  }

  getEmbedUrl(link: string): string {
  if (!link) return '';

  // Check if it is a YouTube link
  if (link.includes('youtube.com') || link.includes('youtu.be')) {
    const videoIdMatch = link.match(/(?:youtube\.com.*(?:\?|&)v=|youtu\.be\/)([^&#]+)/);
    const videoId = videoIdMatch ? videoIdMatch[1] : null;
    return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
  }

  // Return original if not YouTube
  return link;
  }

  openVideoIsAccess(link: any) {
    if (this.isPackageVideo == true) {
      this.videoUrl =this.getEmbedUrl(link);
     // this.videoUrl = 'https://www.youtube.com/embed/OnA2X8IleRI';
      // this.videoUrl = 'https://www.youtube.com/watch?v=eHZ6Re8u8ow';
      //this.videoUrl = 'https://www.youtube.com/embed/OnA2X8IleRI';
      //this.videoUrl = this.getEmbedUrl(link);
    }
    else {
      if (this.UserId == null || this.UserId == undefined || localStorage.getItem('isLoggedIn') == "false") {
        const modalRef = this.modalService.open(LoginWithEmailComponent, { centered: true, backdrop: 'static' ,
      windowClass: 'login-modal-window'});
        modalRef.componentInstance.ctaText = 'Unlock Your Resources';
      }
      else {
        if (this.UnPaidContent) {
          // this.videoUrl = link;
          this.videoUrl = this.getEmbedUrl(link);
        }
        // else if (this.AccessStatus == "TrialPending") {
        //   this.isTrialPending = true;
        //   const modalRef = this.modalService.open(TrialUserComponent, { centered: true, size: 'xl', backdrop: 'static' },);
        //   modalRef.componentInstance.UserId = this.UserId;
        // }
        // else if (this.AccessStatus == "TrialExpired") {
        //   this.isTrialExpired = true;
        //   const modalRef = this.modalService.open(FreeTrialNotifyComponent, { size: 'xl', centered: true, backdrop: 'static' });
        //   modalRef.componentInstance.FreeTrialStatus = this.freeTrialStatus;
        // }
        // else if (this.AccessStatus == "PackageExpired") {
        //   this.isPackageExpired = true;
        //   const modalRef = this.modalService.open(FreeTrialNotifyComponent, { size: 'xl', centered: true, backdrop: 'static' });
        //   modalRef.componentInstance.FreeTrialStatus = this.freeTrialStatus;
        // }
        else {
          // this.videoUrl = link;
          this.videoUrl = this.getEmbedUrl(link);
        }
      }
    }
  }

  closeModal() {
    this.activeModal.close();
  }
}
